import { styled } from '@mui/material/styles'
import { CONTENT_MAX_WIDTH } from '../config'

type PageViewportProps = {
  viewportHeight: number
}

type PageContentShellProps = {
  topbarHeight: number
}

export const PageViewport = styled('main', {
  shouldForwardProp: (prop) => prop !== 'viewportHeight',
})<PageViewportProps>(({ theme, viewportHeight }) => ({
  width: '100%',
  height: viewportHeight,
  overflow: 'auto',
  padding: theme.spacing(2),
  boxSizing: 'border-box',
}))

export const PageContentShell = styled('div', {
  shouldForwardProp: (prop) => prop !== 'topbarHeight',
})<PageContentShellProps>(({ theme, topbarHeight }) => ({
  width: '100%',
  maxWidth: CONTENT_MAX_WIDTH,
  margin: '0 auto',
  marginTop: topbarHeight,
  paddingBottom: theme.spacing(4),
  boxSizing: 'border-box',
}))

export const PageCenteredSection = styled('section')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  paddingTop: theme.spacing(3),
  paddingBottom: theme.spacing(3),
}))
